import React from 'react';
// template components
import AssistiveText from '@nmx/template/dist/componentLibrary/components/AssistiveText';
import CredentialCard from '@nmx/template/dist/componentLibrary/modules/CredentialCard';
import Link from '@nmx/template/dist/componentLibrary/components/Link';
import Row from '@nmx/template/dist/componentLibrary/foundations/Grid/Row';
import SectionContainer from '@nmx/template/dist/componentLibrary/components/SectionContainer';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';
// styles
import {
  ColStyledLeft,
  ColStyledRight,
  DivStyledCardContainer,
  TypographyStyled,
} from './styles';

export default () => (
  <SectionContainer
    id='investment-account-protection-intro'
    backgroundVariant='lightA'
    themeType='lightTheme'
    moduleName='intro-module'
    moduleVariation='A'>
    <Row align='center'>
      <ColStyledLeft
        align='center'
        medium={8}
        large={9}>
        <AssistiveText component='h2'>
          Opening an investment <WidowBlock>protection account</WidowBlock>
        </AssistiveText>
        <Typography
          align='left'
          nextElement='typography'>
          When you open an investment account at Northwestern Mutual, you&#39;re working with one of the&nbsp;
          <Link
            id='investment-account-protection-financial-info-link'
            variant='primaryDeemphasize'
            linkUrl='/financial-information/'>
            strongest companies
          </Link> in America. Northwestern Mutual manages more than &#36;246 billion<sup>1</sup> of retail investment client assets and is a top 5 independent broker&#45;dealer.<sup>2</sup>
        </Typography>
        <TypographyStyled
          align='left'
          disableBottomPadding>
          And investment accounts at Northwestern Mutual come with automatic third&#45;party protection.
        </TypographyStyled>
      </ColStyledLeft>
      <ColStyledRight
        medium={4}
        large={3}>
        <DivStyledCardContainer>
          <CredentialCard
            backgroundVariant='lightA'
            credential='rankedInvestmentService'
            sup1='2'
          />
        </DivStyledCardContainer>
      </ColStyledRight>
    </Row>
  </SectionContainer>
);
